if(!customElements.get('zoom-container')) {
  class ZoomContainer extends HTMLElement {
    constructor() {
      super();
      this.element = document.querySelector(`#${this.id}`);
      this.background = this.element.querySelector('.js-zoom');
      this.isZoomed = false;

      this.addEventListener('click', () => {
        if(window.innerWidth > 750) {
          this.toggleEventDesktop();
        } else {
          this.toggleEventMobile();
        }
      });
    }

    zoom(e) {
      const zoomer = this.background;
      let offsetX = e.offsetX;
      let offsetY = e.offsetY;
      let x = offsetX / zoomer.offsetWidth * 100;
      let y = offsetY / zoomer.offsetHeight * 100;
      zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }

    toggleEventDesktop() {
      let image_index = this.dataset.imageIndex;

      const zoomContainerDesktopTemplate = document.getElementById('zoom-container-desktop-template');
      let DesktopTemplate = zoomContainerDesktopTemplate.innerHTML;

      const zoomContainerDesktopThumbnailTemplate = document.getElementById('zoom-container-desktop-thumbnail-template');
      let DesktopThumbnailTemplate = zoomContainerDesktopThumbnailTemplate.innerHTML;

      const zoomDesktopContainer = document.createElement("div");
      zoomDesktopContainer.classList.add("zoom-container-desktop");

      let active_media_slides = document.querySelectorAll(".product__slide.js-main-slide .zoom-container");

      if(active_media_slides.length == 0)
      {
        active_media_slides = document.querySelectorAll(".product__slide .zoom-container");
      }

      let ZoomContainerThumbnails = "";

      for(let i=0;i<active_media_slides.length;i++)
      {
        let is_active_class = "";
        let thumbnail = DesktopThumbnailTemplate;
        if(image_index == active_media_slides[i].dataset.imageIndex)
        {
          is_active_class = "thumbnail-active";
        }
        thumbnail = thumbnail.replace(/ZoomContainerThumbnailActive/g, is_active_class);
        thumbnail = thumbnail.replace(/ZoomContainerThumbnailId/g, "thumbnail-" + i);
        thumbnail = thumbnail.replace(/ZoomImageSource/g, active_media_slides[i].dataset.zoomImage);
        thumbnail = thumbnail.replace(/ZoomContainerThumbnailImage/g, active_media_slides[i].dataset.thumbnailImage);

        ZoomContainerThumbnails += thumbnail;
      }

      DesktopTemplate = DesktopTemplate.replace(/ZoomContainerThumbnails/g, ZoomContainerThumbnails);

      DesktopTemplate = DesktopTemplate.replace(/ZoomContainerTitle/g, this.dataset.productTitle);
      DesktopTemplate = DesktopTemplate.replace(/ZoomContainerImage/g, this.dataset.zoomImage);

      DesktopTemplate = DesktopTemplate.replace(/zoomContainerClose/g, window.theme.elements.svg_close);

      zoomDesktopContainer.innerHTML = DesktopTemplate;
      document.body.appendChild(zoomDesktopContainer);

      const zoomedPanel = document.querySelector(".right-panel-zoomed");
      this.setupImageZoom(zoomedPanel);

      const image_thumbnails = document.querySelectorAll(".image-thumbnail");
      this.setupThumbnailClick(zoomedPanel, image_thumbnails);

      document.body.classList.add("no-scroll");

      document.querySelector('.product-media-modal-desktop__toggle').addEventListener('click', (event) => {
        document.querySelector('.zoom-container-desktop').remove();
        document.body.classList.remove("no-scroll");
      });
      if (image_thumbnails.length > 4) {
        this.setupThumbnailScrolling();
      }
    }

    setupImageZoom(zoomedObject) {
      zoomedObject.scrollLeft = (zoomedObject.querySelector('img').width - zoomedObject.clientWidth) / 2;
      zoomedObject.scrollTop = (zoomedObject.querySelector('img').height - zoomedObject.clientHeight) / 2;

      zoomedObject.querySelector('img').addEventListener('mousemove', (event) => {
        let offsetX = event.offsetX;
        let offsetY = event.offsetY;
        let x = offsetX / zoomedObject.offsetWidth * 100;
        let y = offsetY / zoomedObject.offsetHeight * 100;
        zoomedObject.style.backgroundPosition = x + '% ' + y + '%';
        zoomedObject.classList.add("is-zoomed");
      });

      zoomedObject.querySelector('img').addEventListener('mouseover', (event) => {
        zoomedObject.classList.add("is-zoomed");
      });

      zoomedObject.querySelector('img').addEventListener('mouseout', (event) => {
        zoomedObject.classList.remove("is-zoomed");
      });
    }

    setupThumbnailClick(zoomedObject, thumbnails) {
      for(let i=0;i<thumbnails.length;i++)
      {
        thumbnails[i].addEventListener('click', (event) => {
          document.querySelector(".thumbnail-active").classList.remove("thumbnail-active");
          let new_image = thumbnails[i].querySelector("img").getAttribute("zoomed-image");
          zoomedObject.querySelector('img').setAttribute("src", new_image);
          zoomedObject.style.backgroundImage = "url('"+ new_image + "')";
          thumbnails[i].querySelector("img").classList.add("thumbnail-active");
        });
      }

      document.addEventListener('keyup', function(event) {
        const activeThumbnail = document.querySelector('.thumbnail-active');
        let currentIndex = Array.prototype.indexOf.call(thumbnails, activeThumbnail.parentElement);

        if (event.key === 'ArrowUp') {
          if (currentIndex > 0) {
            let newIndex = currentIndex - 1;
            changeActiveThumbnail(newIndex);
          }
        } else if (event.key === 'ArrowDown') {
          if (currentIndex < thumbnails.length - 1) {
            let newIndex = currentIndex + 1;
            changeActiveThumbnail(newIndex);
          }
        }

        function changeActiveThumbnail(newIndex) {
          activeThumbnail.classList.remove('thumbnail-active');
          let new_image = thumbnails[newIndex].querySelector('img').getAttribute('zoomed-image');
          zoomedObject.querySelector('img').setAttribute('src', new_image);
          zoomedObject.style.backgroundImage = "url('" + new_image + "')";
          thumbnails[newIndex].querySelector('img').classList.add('thumbnail-active');

          const thumbnailContainer = document.querySelector('.zoom-container-desktop .thumbnails-image-box');
          const thumbnailHeight = thumbnails[newIndex].getBoundingClientRect().height;
          const containerHeight = thumbnailContainer.getBoundingClientRect().height;

          const thumbnailTop = thumbnails[newIndex].offsetTop;
          const containerScrollTop = thumbnailContainer.scrollTop;

          if (thumbnailTop < containerScrollTop || thumbnailTop + thumbnailHeight > containerScrollTop + containerHeight) {
            thumbnailContainer.scrollTop = thumbnailTop - thumbnailHeight / 2;
          }
        }
      });
    }

    setupThumbnailScrolling() {
      const thumbnailContainer = document.querySelector('.zoom-container-desktop .thumbnails-image-box');
      const thumbnails = Array.from(thumbnailContainer.querySelectorAll('.image-thumbnail'));
      const thumbnailHeight = thumbnails[0]?.getBoundingClientRect().height || 0;
      const numberVisible = 4;
      let currentIndex = 0;
      const thumbnailStyle = window.getComputedStyle(thumbnails[0]);
      const marginTop = parseFloat(thumbnailStyle.marginTop);
      const marginBottom = parseFloat(thumbnailStyle.marginBottom);
      const totalMargin = marginTop + marginBottom;
      const totalMarginOfContainer = totalMargin * numberVisible;
      thumbnailContainer.style.scrollBehavior = 'smooth'; // Add smooth scrolling behavior

      thumbnailContainer.insertAdjacentHTML('afterend', `
        <span class="up-arrow arrow">${window.theme.elements.svg_arrow_up}</span>
        <span class="down-arrow arrow">${window.theme.elements.svg_arrow_up}</span>
      `);

      const containerHeight = thumbnailHeight * numberVisible + totalMarginOfContainer;
      thumbnailContainer.style.height = `${containerHeight}px`;

      const upArrow = document.querySelector('.up-arrow');
      const downArrow = document.querySelector('.down-arrow');

      function updateArrows() {
        const scrollTop = thumbnailContainer.scrollTop;
        const scrollBottom = thumbnailContainer.scrollHeight - thumbnailContainer.clientHeight;

        upArrow.style.display = scrollTop === 0 ? 'none' : 'inline';
        downArrow.style.display = scrollTop >= scrollBottom ? 'none' : 'inline';
      }

      updateArrows();

      document.querySelector('.down-arrow').addEventListener('click', () => {
        currentIndex = Math.min(currentIndex + 1, thumbnails.length - numberVisible);
        thumbnailContainer.scrollTop += thumbnailHeight + totalMargin; // Smooth scrolling using scrollTop
        updateArrows();
      });

      document.querySelector('.up-arrow').addEventListener('click', () => {
        currentIndex = Math.max(currentIndex - 1, 0);
        thumbnailContainer.scrollTop -= thumbnailHeight + totalMargin; // Smooth scrolling using scrollTop
        updateArrows();
      });

      thumbnailContainer.addEventListener('scroll', updateArrows);

      document.querySelectorAll(".image-thumbnail").forEach((div, index) => {
        if (div.querySelector('.thumbnail-active')) {
          if (index >= numberVisible ){
            currentIndex = index + 1;
            currentIndex -= numberVisible;
            thumbnailContainer.scrollTop = currentIndex * (thumbnailHeight + totalMargin); // Set initial scroll position
            updateArrows();
          }
        }
      });
    }


    toggleEventMobile() {
      const div = document.createElement("div");
      div.classList.add("zoom-container-mobile");
      div.innerHTML = `<button class="product-media-modal__toggle" aria-label="close" onClick="document.querySelector('.zoom-container-mobile').remove()">${window.theme.elements.svg_close}</button><img onClick="document.querySelector('.zoom-container-mobile').remove()" src="${this.dataset.zoomImage}" alt="" width="" height="" />`;
      document.body.appendChild(div);
      const container = document.querySelector(".zoom-container-mobile");
      container.scrollLeft = (container.querySelector('img').width - container.clientWidth) / 2;
      container.scrollTop = (container.querySelector('img').height - container.clientHeight) / 2;
    }
  }

  customElements.define('zoom-container',ZoomContainer);
}
